export default class EventFilter {
  constructor(el) {
    this.el = el;
    this.filtercategories = this.el.dataset.categories
      .split(',')
      .map((cat) => cat.trim());

    //fetch categories feed then call insertCategoryFilter
    fetch('/feeds/eventscategories/?getcat=1')
      .then((response) => response.json())
      .then((data) => {
        this.categories = data;
        this.insertCategoryFilter();
      });
  }

  getCategoryById(id) {
    //fetch query to get category by id
    const filteredcat = this.categories.filter((cat) => {
      if (cat.categoryid == id) {
        return cat;
      }
    });
    return {
      id: id,
      name: filteredcat[0].name,
    };
  }

  insertCategoryFilter() {
    //drop down containing all categories
    let select = document.createElement('select');

    select.classList.add('category-filter');
    select.addEventListener('change', (event) => {
      this.filterTilesByCategoryId(event.target.value);
    });
    select.insertAdjacentHTML('afterbegin', `<option value="">All</option>`);
    this.filtercategories.forEach((category) => {
      select.insertAdjacentHTML(
        'beforeend',
        `<option value="${category}">${this.getCategoryById(category).name}</option>`
      );
    });
    this.el.insertAdjacentElement('beforebegin', select);
  }

  filterTilesByCategoryId(id) {
    console.log(id);
    let tiles = [];
    if (id !== '') {
      tiles = [...document.querySelectorAll('.tileContainer')].map((el) => {
        return { el: el, show: el.dataset.cat.split(',').includes(id) };
      });
    } else {
      tiles = [...document.querySelectorAll('.tileContainer')].map((el) => {
        return { el: el, show: true };
      });
    }
    tiles.forEach((item) => {
      item.show
        ? item.el.classList.remove('hide')
        : item.el.classList.add('hide');
    });
    new window.parseTiles('.tileContainer');
    return;
  }
}
